/// Télécharge une chaîne UTF-8 côté navigateur (sans appel serveur).
export function downloadTextAsFile(content: string, filename: string): void {
  const blob = new Blob([content], { type: "text/markdown;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

/** Nom de fichier sûr à partir d'un titre affiché. */
export function markdownFilenameFromTitle(
  title: string | null | undefined,
  fallback: string,
): string {
  const base =
    (title ?? "")
      .trim()
      .normalize("NFD")
      .replace(/\p{M}/gu, "")
      .replace(/[^a-zA-Z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 80) || fallback;
  return `${base}.md`;
}
